// Generated file : do not modify
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Autentification SSO
export default class Sso  {
  // Paramètres
  public param: string;

  constructor() {
    this.param = '';
  }

  public static fromJson (obj: Sso): Sso {
    const newSso: Sso = new Sso();
    newSso.param = obj.param;
    return newSso;
  }

  public toJsonSso (): string {
    const json = {
      param: this.param,
    }
    return JSON.stringify(json);
  }

  public fromSso (obj: Sso): void {
    this.param = obj.param;
  }

  public compareSso (value: Sso): boolean {
    return (this.toJsonSso() == value.toJsonSso());
  }

  public cloneSso (): Sso {
    return Sso.fromJson(this);
  }

  public static redirection (): Promise<string> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/sso/redirection', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static authen (sso: Sso): Promise<string> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/sso/authen', sso, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(ssos: Sso[]) {
  }
}
